<template>
  <div class="page" style="margin-top: -80px">
    <div id="printDiv" v-show="printShow">
      <COAPowder :printModel="this.$data" style="height-max: 1000px; width: 91vw;" ></COAPowder>
    </div>
    <div v-if="isShowAlonePrint" style="width:21cm;margin-left:25%;">
      <div id="alonePrintDiv">
        <COAPowder :printModel="this.$data" style="height-max: 1000px;" ></COAPowder>
      </div>
      <div style="margin-top: 50px;">
        <el-button type="info" icon="el-icon-edit" @click="showUpdate()" v-if="isShowUpdate">Update</el-button>
        <el-button type="success" icon="el-icon-printer" @click="aloneprintPage()">Print</el-button>
        <el-button type="info" @click="closePage()">Exit</el-button>
      </div>
    </div>
    <center v-else>
      <div class="new-item-content" style="margin: 40px 0 40px 0;">
        <!-- Base Info -->
        <div class="base-info">
          <div></div>
          <div>
            <div>
              <span>Edit Print Title：</span>

              <div class="el-input" style="text-align: left">
                <el-checkbox
                  v-model="form.BaseInfoEditPrintTitleCheckbox"
                  placeholder="Please Input"
                ></el-checkbox>
                <el-input
                  v-show="form.BaseInfoEditPrintTitleCheckbox"
                  v-model="form.BaseInfoEditPrintTitle"
                  placeholder="Please Input"
                  style="margin-left: 10px; width: 575px"
                ></el-input>
              </div>
            </div>
            <!-- <div>
              <span>Custom Product Name：</span>
              <el-input
                v-model="form.BaseInfoCustomProductName"
                placeholder="Please Input"
              ></el-input>
            </div> -->
            <div>
              <span>Country of Origin：</span>
              <el-input
                v-model="form.BaseInfoCountryofOrigin"
                placeholder="Please Input"
              ></el-input>
            </div>
            <div>
              <span>Customer PO Number：</span>
              <div class="el-input" style="text-align: left">
                <el-checkbox
                  v-model="form.BaseInfoCustomerPONumber"
                  placeholder="Please Input"
                ></el-checkbox>
                <el-input
                  v-show="form.BaseInfoCustomerPONumber"
                  v-model="form.BaseInfoCustomerPONumberText"
                  placeholder="Please Input"
                  style="margin-left: 10px; width: 575px"
                ></el-input>
              </div>
            </div>
            <div>
              <span>Customer Code：</span>
              <div class="el-input" style="text-align: left">
                <el-checkbox
                  v-model="form.BaseInfoCustomerCodeCheckbox"
                ></el-checkbox>
                <el-input
                  v-model="form.BaseInfoCustomerCode"
                  placeholder="Please Input"
                  style="margin-left: 10px; width: 575px"
                  v-show="form.BaseInfoCustomerCodeCheckbox"
                ></el-input>
              </div>
            </div>
            <div style="margin: 0 0 0 0">
              <span style="width: 500px; margin-left: -200px"
                >Country of Origin Feedstock and Country of Origin
                Extraction：</span
              >
              <div class="el-input" style="text-align: left">
                <el-checkbox
                  v-model="form.BaseInfoCOfOFAndCOfOE"
                  placeholder="Please Input"
                ></el-checkbox>
                <el-input
                  v-model="form.BaseInfoCOfOFAndCOfOEText"
                  placeholder="Please Input"
                  style="margin-left: 10px; width: 575px"
                  v-show="form.BaseInfoCOfOFAndCOfOE"
                ></el-input>
              </div>
            </div>
            <div>
              <span>SAP Number：</span>
              <div class="el-input" style="text-align: left">
                <el-checkbox v-model="form.BaseInfoSAPNumber"></el-checkbox>
                <el-input
                  v-model="form.BaseInfoSAPNumberText"
                  placeholder="Please Input"
                  style="margin-left: 10px; width: 575px"
                  v-show="form.BaseInfoSAPNumber"
                ></el-input>
              </div>
            </div>
            <div>
              <span>Manufacturing Date：</span>
              <el-date-picker
                v-model="form.BaseInfoManufacturingDate"
                placeholder="Please Select Date"
                type="month"
                @on-change="date=$event"
                @change="manufacturingDateChange"
              ></el-date-picker>
            </div>
            <div>
              <span>Expiration Date：</span>
              <el-date-picker
                v-model="form.BaseInfoExpirationDate"
                placeholder="Please Select Date"
                type="month"
                @on-change="date=$event"
              ></el-date-picker>
            </div>

            <div>
              <span>
                <el-input
                  v-model="form.BaseInfoCustomRowKey1"
                  class="custom-row"
                  placeholder="Please Input"
                  style="width: 50%"
                ></el-input
                >：</span
              >
              <div class="custom-row el-input">
                <el-input
                  v-model="form.BaseInfoCustomRowValue1"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div>
            </div>
            <div>
              <span>
                <el-input
                  v-model="form.BaseInfoCustomRowKey2"
                  class="custom-row"
                  placeholder="Please Input"
                  style="width: 50%"
                ></el-input
                >：</span
              >
              <div class="custom-row el-input">
                <el-input
                  v-model="form.BaseInfoCustomRowValue2"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <!-- General Specification -->
        <div class="base-info">
          <div>General Specification</div>
          <div>
            <div style="height: auto">
              <span>Ingredients：</span>
              <!-- <el-input
                v-model="form.GeneralSpecIngredients"
                placeholder="Please Input"
              ></el-input> -->

              <div
                style="display: inline-block; width: 615px; text-align: left"
              >
                <div
                  style="
                    display: flex;
                    justify: flex-start;
                    flex-wrap: wrap;
                    align-items: center;
                  "
                >
                  <el-tag
                    :key="i"
                    v-for="(tag, i) in ingredientsArr"
                    closable
                    :disable-transitions="false"
                    @click="tagHandle(ingredientsArr, tag, i)"
                    @close="handleClose(tag, 'ingredientsArr')"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="
                      handleInputConfirm(
                        'inputValue',
                        'ingredientsArr',
                        'inputVisible'
                      )
                    "
                    @blur="
                      handleInputConfirm(
                        'inputValue',
                        'ingredientsArr',
                        'inputVisible'
                      )
                    "
                  ></el-input>
                  <el-button
                    :disabled="ingredientsD"
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInput('inputVisible', 'saveTagInput')"
                    >+ New Ingredient</el-button
                  >
                </div>
              </div>
            </div>
            <div>
              <span>Product Grade：</span>
              <el-input
                v-model="form.GeneralSpecProductGrade"
                placeholder="Please Input"
              ></el-input>
            </div>
            <div style="height: auto">
              <span>INCI name：</span>
              <!-- <el-input
                v-model="form.GeneralSpecINCIName"
                placeholder="Please Input"
              ></el-input> -->

              <div
                style="display: inline-block; width: 615px; text-align: left"
              >
                <div
                  style="
                    display: flex;
                    justify: flex-start;
                    flex-wrap: wrap;
                    align-items: center;
                  "
                >
                  <el-tag
                    :key="i"
                    v-for="(tag, i) in inclNameArr"
                    closable
                    :disable-transitions="false"
                    @click="tagHandle(inclNameArr, tag, i)"
                    @close="handleClose(tag, 'inclNameArr')"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="inclNameInputVisible"
                    v-model="inclNameInputValue"
                    ref="inclNameSaveTagInput"
                    size="small"
                    @keyup.enter.native="
                      handleInputConfirm(
                        'inclNameInputValue',
                        'inclNameArr',
                        'inclNameInputVisible'
                      )
                    "
                    @blur="
                      handleInputConfirm(
                        'inclNameInputValue',
                        'inclNameArr',
                        'inclNameInputVisible'
                      )
                    "
                  ></el-input>
                  <el-button
                    :disabled="inciNameD"
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="
                      showInput('inclNameInputVisible', 'inclNameSaveTagInput')
                    "
                    >+ New InclName</el-button
                  >
                </div>
              </div>
            </div>
            <div style="height: auto">
              <span>Botanical Name：</span>
              <!-- <el-input
                v-model="form.GeneralSpecBotanicalName"
                placeholder="Please Input"
              ></el-input> -->

              <div
                style="display: inline-block; width: 615px; text-align: left"
              >
                <div
                  style="
                    display: flex;
                    justify: flex-start;
                    flex-wrap: wrap;
                    align-items: center;
                  "
                >
                  <el-tag
                    :key="i"
                    v-for="(tag, i) in botanicalNameArr"
                    closable
                    :disable-transitions="false"
                    @click="tagHandle(botanicalNameArr, tag, i)"
                    @close="handleClose(tag, 'botanicalNameArr')"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="botanicalNameInputVisible"
                    v-model="botanicalNameInputValue"
                    ref="botanicalNameSaveTagInput"
                    size="small"
                    @keyup.enter.native="
                      handleInputConfirm(
                        'botanicalNameInputValue',
                        'botanicalNameArr',
                        'botanicalNameInputVisible'
                      )
                    "
                    @blur="
                      handleInputConfirm(
                        'botanicalNameInputValue',
                        'botanicalNameArr',
                        'botanicalNameInputVisible'
                      )
                    "
                  ></el-input>
                  <el-button
                    :disabled="botanicalNameD"
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="
                      showInput(
                        'botanicalNameInputVisible',
                        'botanicalNameSaveTagInput'
                      )
                    "
                    >+ New botanicalName</el-button
                  >
                </div>
              </div>
            </div>
            <div style="height: auto">
              <span>Common Name/Other Name：</span>
              <!-- <el-input
                v-model="form.GeneralSpecCommonNameOrOtherName"
                class="custom-row"
                placeholder="Please Input"
              ></el-input> -->

              <div
                style="display: inline-block; width: 615px; text-align: left"
              >
                <div
                  style="
                    display: flex;
                    justify: flex-start;
                    flex-wrap: wrap;
                    align-items: center;
                  "
                >
                  <el-tag
                    :key="i"
                    v-for="(tag, i) in commonNameArr"
                    closable
                    :disable-transitions="false"
                    @click="tagHandle(commonNameArr, tag, i)"
                    @close="handleClose(tag, 'commonNameArr')"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="commonNameInputVisible"
                    v-model="commonNameInputValue"
                    ref="commonNameSaveTagInput"
                    size="small"
                    @keyup.enter.native="
                      handleInputConfirm(
                        'commonNameInputValue',
                        'commonNameArr',
                        'commonNameInputVisible'
                      )
                    "
                    @blur="
                      handleInputConfirm(
                        'commonNameInputValue',
                        'commonNameArr',
                        'commonNameInputVisible'
                      )
                    "
                  ></el-input>
                  <el-button
                    :disabled="commonNameD"
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="
                      showInput(
                        'commonNameInputVisible',
                        'commonNameSaveTagInput'
                      )
                    "
                    >+ New CommonName</el-button
                  >
                </div>
              </div>
            </div>
            <div style="height: auto">
              <span>Part Used：</span>
              <!-- <el-input
                v-model="form.GeneralSpecPartUsed"
                class="custom-row"
                placeholder="Please Input"
              ></el-input> -->

              <div
                style="display: inline-block; width: 615px; text-align: left"
              >
                <div
                  style="
                    display: flex;
                    justify: flex-start;
                    flex-wrap: wrap;
                    align-items: center;
                  "
                >
                  <el-tag
                    :key="i"
                    v-for="(tag, i) in partUsedArr"
                    closable
                    :disable-transitions="false"
                    @click="tagHandle(partUsedArr, tag, i)"
                    @close="handleClose(tag, 'partUsedArr')"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="partUsedInputVisible"
                    v-model="partUsedInputValue"
                    ref="partUsedSaveTagInput"
                    size="small"
                    @keyup.enter.native="
                      handleInputConfirm(
                        'partUsedInputValue',
                        'partUsedArr',
                        'partUsedInputVisible'
                      )
                    "
                    @blur="
                      handleInputConfirm(
                        'partUsedInputValue',
                        'partUsedArr',
                        'partUsedInputVisible'
                      )
                    "
                  ></el-input>
                  <el-button
                    :disabled="partUsedD"
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="
                      showInput('partUsedInputVisible', 'partUsedSaveTagInput')
                    "
                    >+ New Part Used</el-button
                  >
                </div>
              </div>
            </div>
            <div style="height: auto">
              <span>Percentage：</span>
              <!-- <div class="custom-row el-input">
                <el-input
                  v-model="form.GeneralSpecPercentage"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div> -->
              <div
                style="display: inline-block; width: 615px; text-align: left"
              >
                <div
                  style="
                    display: flex;
                    justify: flex-start;
                    flex-wrap: wrap;
                    align-items: center;
                  "
                >
                  <!-- (tag,i) in ingredientsTags(2) -->
                  <el-tag
                    :key="i"
                    v-for="(tag, i) in percentageArr"
                    closable
                    :disable-transitions="false"
                    @click="tagHandle(percentageArr, tag, i)"
                    @close="handleClose(tag, 'percentageArr')"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="percentageInputVisible"
                    v-model="percentageInputValue"
                    ref="percentageSaveTagInput"
                    size="small"
                    @keyup.enter.native="
                      handleInputConfirm(
                        'percentageInputValue',
                        'percentageArr',
                        'percentageInputVisible'
                      )
                    "
                    @blur="
                      handleInputConfirm(
                        'percentageInputValue',
                        'percentageArr',
                        'percentageInputVisible'
                      )
                    "
                  ></el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="
                      showInput(
                        'percentageInputVisible',
                        'percentageSaveTagInput'
                      )
                    "
                    >+ New Percentage</el-button
                  >
                </div>
              </div>
            </div>
            
          <div style="height: auto">
            <div style="display: inline-block; text-align: left">
            <table style="border: 1px solid #eee;">
              <tr>
                <td style="border: 1px solid #eee;">
                  <el-input placeholder="Please Input" style="width: 100%" v-model="form.tableInput1"></el-input>
                </td>
                <td style="border: 1px solid #eee;">
                  <el-input placeholder="Please Input" style="width: 100%" v-model="form.tableInput2"></el-input>
                </td>
                <td style="border: 1px solid #eee;">
                  <el-input placeholder="Please Input" style="width: 100%" v-model="form.tableInput3"></el-input>
                </td>
                <td style="border: 1px solid #eee;">
                  <el-input placeholder="Please Input" style="width: 100%" v-model="form.tableInput4"></el-input>
                </td>
                <td style="border: 1px solid #eee;">
                  <el-input placeholder="Please Input" style="width: 100%" v-model="form.tableInput5"></el-input>
                </td>
                <td>
                  <el-button type="primary" class="button-new-tag" size="small" @click="addTableInput(1, 0)">+</el-button>
                </td>
              </tr>
              <tr v-for="(item, tableInputIndex) in tableInputCustomFieldAttr" :key="tableInputIndex + 1">
                <td style="border: 1px solid #eee;">
                  <el-input placeholder="Please Input" style="width: 100%" v-model="item.tableInput1"></el-input>
                </td>
                <td style="border: 1px solid #eee;">
                  <el-input placeholder="Please Input" style="width: 100%" v-model="item.tableInput2"></el-input>
                </td>
                <td style="border: 1px solid #eee;">
                  <el-input placeholder="Please Input" style="width: 100%" v-model="item.tableInput3"></el-input>
                </td>
                <td style="border: 1px solid #eee;">
                  <el-input placeholder="Please Input" style="width: 100%" v-model="item.tableInput4"></el-input>
                </td>
                <td style="border: 1px solid #eee;">
                  <el-input placeholder="Please Input" style="width: 100%" v-model="item.tableInput5"></el-input>
                </td>
                <td>
                  <el-button type="primary" class="button-new-tag" size="small" @click="addTableInput(1, 0)">+</el-button>
                  <el-button type="danger" class="button-new-tag" size="small" @click="addTableInput(0, tableInputIndex)">-</el-button>
                </td>
              </tr>
            </table>
            </div>
          </div>

            <div>
              <span>Extraction Ratio：</span>
              <div class="custom-row el-input">
                <el-input
                  v-model="form.GeneralSpecExtractionRatio"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div>
            </div>
            <div>
              <span>Important Constituents in Plant：</span>
              <el-input
                v-model="form.GeneralSpecImportantConstituentsInPlant"
                placeholder="Please Input"
              ></el-input>
            </div>
            <div>
              <span>Harvest method：</span>
              <div class="el-input" style="text-align: left">
                <el-checkbox
                  v-model="form.GeneralSpecHarvestMethod"
                ></el-checkbox>
                <el-input
                  v-model="form.GeneralSpecHarvestMethodText"
                  placeholder="Please Input"
                  style="margin-left: 10px; width: 575px"
                  v-show="form.GeneralSpecHarvestMethod"
                ></el-input>
              </div>
            </div>
            <div>
              <span>Appearance：</span>
              <el-input
                v-model="form.GeneralSpecAppearance"
                placeholder="Please Input"
              ></el-input>
            </div>
            <div>
              <span>Solubility：</span>
              <el-input
                v-model="form.GeneralSpecSolubility"
                placeholder="Please Input"
              ></el-input>
            </div>
            <div>
              <span>Homogeneity：</span>
              <el-input
                v-model="form.GeneralSpecHomogeneity"
                class="custom-row"
                placeholder="Please Input"
              ></el-input>
            </div>
            <div>
              <span>Extraction Process：</span>
              <el-input
                v-model="form.GeneralSpecExtractionProcess"
                class="custom-row"
                placeholder="Please Input"
              ></el-input>
            </div>
            <div>
              <span>Processing Aid：</span>
              <el-input
                v-model="form.GeneralSpecProcessingAid"
                class="custom-row"
                placeholder="Please Input"
              ></el-input>
            </div>
            <div>
              <span>Solvent for Extraction：</span>
              <div class="custom-row el-input">
                <el-input
                  v-model="form.GeneralSpecSolventForExtraction"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div>
            </div>
            <div>
              <span>Carrier：</span>
              <div class="custom-row el-input">
                <el-input
                  v-model="form.GeneralSpecCarrier"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div>
            </div>
            <div>
              <span>Pesticides：</span>
              <div class="custom-row el-input">
                <el-input
                  v-model="form.GeneralSpecPesticides"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div>
            </div>
            <div>
              <span>Certification：</span>
              <div class="custom-row el-input">
                <el-input
                  v-model="form.GeneralSpecCertification"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div>
            </div>

            <div>
              <span
                ><el-input
                  v-model="form.GeneralSpecCustomRowKey1"
                  class="custom-row"
                  placeholder="Please Input"
                  style="width: 50%"
                ></el-input
                >：</span
              >
              <div class="custom-row el-input">
                <el-input
                  v-model="form.GeneralSpecCustomRowValue1"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div>
            </div>
            <div>
              <span
                ><el-input
                  v-model="form.GeneralSpecCustomRowKey2"
                  class="custom-row"
                  placeholder="Please Input"
                  style="width: 50%"
                ></el-input
                >：</span
              >
              <div class="custom-row el-input">
                <el-input
                  v-model="form.GeneralSpecCustomRowValue2"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div>
            </div>

            <div>
              <span style="margin-left: 48px">
                <el-input
                  v-model="form.GeneralSpecCustomRowKey3"
                  class="custom-row"
                  placeholder="Please Input"
                  style="width: 50%"
                ></el-input
                >：</span
              >
              <div class="custom-row el-input">
                <el-input
                  v-model="form.GeneralSpecCustomRowValue3"
                  class="custom-row"
                  placeholder="Please Input"
                ></el-input>
              </div>
              <el-button
                type="primary"
                class="button-new-tag"
                size="small"
                @click="addGenSpecCustomRow(1, 0)"
                >+</el-button>
            </div>

            <div
              v-for="(item, genSpecIndex) in genSpecCustomFieldAttr"
              :key="genSpecIndex + 1"
            >
              <span style="margin-left: 96px">
                <el-input
                  v-model="item.customKey"
                  placeholder="Please Name Input"
                  class="custom-row"
                  style="width: 50%"
                ></el-input
                >：</span
              >
              <div class="custom-row el-input">
                <el-input
                  v-model="item.customValue"
                  class="custom-row"
                  placeholder="Please Value Input"
                ></el-input>
              </div>
              <el-button
                type="primary"
                class="button-new-tag"
                size="small"
                @click="addGenSpecCustomRow(1, genSpecIndex)"
                >+</el-button
              >
              <el-button
                type="danger"
                class="button-new-tag"
                size="small"
                @click="addGenSpecCustomRow(0, genSpecIndex)"
                >-</el-button
              >
            </div>
          </div>
        </div>
        <!-- Analysis -->
        <div class="base-info">
          <div>Analysis</div>
          <div>
            <table
              class="AnalysisTable"
              border="1"
              cellspacing="0"
              cellpadding="0"
            >
              <tr>
                <td style="width: 25%" class="FontWeight">Test Item</td>
                <td style="width: 25%" class="FontWeight">Specification</td>
                <td style="width: 25%" class="FontWeight">Result</td>
                <td style="width: 25%" class="FontWeight">Test Method</td>
              </tr>
              <tr>
                <td class="FontWeight">STANDARD 1</td>
                <td>
                  <el-input
                    v-model="form.SpecificationSTANDARD1"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultSTANDARD1"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodSTANDARD1"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">STANDARD 2</td>
                <td>
                  <el-input
                    v-model="form.SpecificationSTANDARD2"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultSTANDARD2"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodSTANDARD2"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">STANDARD 3</td>
                <td>
                  <el-input
                    v-model="form.SpecificationSTANDARD3"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultSTANDARD3"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodSTANDARD3"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Mesh Size</td>
                <td>
                  <el-input
                    v-model="form.SpecificationMeshSize"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultMeshSize"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="append">
                      <div style="width: 100%">Mesh</div>
                    </template>
                  </el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodMeshSize"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Loss on Drying</td>
                <td>
                  <el-input
                    v-model="form.SpecificationLossOnDrying"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="prepend">
                      <div style="width: 100%">&lt;</div>
                    </template>
                    <template slot="append">
                      <div style="width: 100%">%</div>
                    </template>
                  </el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultLossOnDrying"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodLossOnDrying"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Bulk Density</td>
                <td>
                  <el-input
                    v-model="form.SpecificationBulkDensity"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="append">
                      <div style="width: 100%">g/mL</div>
                    </template>
                  </el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultBulkDensity"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="append">
                      <div style="width: 100%">g/mL</div>
                    </template></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodBulkDensity"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>

              <tr>
                <td class="FontWeight">Identification</td>
                <td>
                  <el-input
                    v-model="form.SpecificationIdentification"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultIdentification"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodIdentification"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>

              <tr>
                <td class="FontWeight">Total Heavy Metals</td>
                <td>
                  <el-input
                    v-model="form.SpecificationTotalHeavyMetals"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="prepend">
                      <div style="width: 100%">&lt;</div>
                    </template>
                    <template slot="append">
                      <div style="width: 100%">ppm</div>
                    </template>
                  </el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultTotalHeavyMetals"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="append">
                      <div style="width: 100%">ppm</div>
                    </template>
                  </el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodTotalHeavyMetals"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Arsenic</td>
                <td>
                  <el-input
                    v-model="form.SpecificationArsenic"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="append">
                      <div style="width: 100%">ppm</div>
                    </template></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultArsenic"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodArsenic"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Cadmium</td>
                <td>
                  <el-input
                    v-model="form.SpecificationCadmium"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="append">
                      <div style="width: 100%">ppm</div>
                    </template></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultCadmium"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodCadmium"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Lead</td>
                <td>
                  <el-input
                    v-model="form.SpecificationLead"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="append">
                      <div style="width: 100%">ppm</div>
                    </template></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultLead"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodLead"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>

              <tr>
                <td class="FontWeight">Mercury</td>
                <td>
                  <el-input
                    v-model="form.SpecificationMercury"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="append">
                      <div style="width: 100%">ppm</div>
                    </template></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultMercury"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodMercury"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              
              

              <tr>
                <td class="FontWeight">
                  <el-input
                    v-model="form.SpecificationCustomRowKey1"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.SpecificationCustomRowValue1"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultCustomRowValue1"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodCustomRowValue1"
                    class="InputWidth"
                    placeholder="Please Input"
                    style="width: 50%"
                  ></el-input>
                </td>
              </tr>
              
              <tr>
                <td class="FontWeight">
                  <el-input
                    v-model="form.SpecificationCustomRowKey2"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.SpecificationCustomRowValue2"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultCustomRowValue2"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodCustomRowValue2"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
              </tr>

              <tr>
                <td class="FontWeight">
                  <el-input
                    v-model="form.SpecificationCustomRowKey3"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.SpecificationCustomRowValue3"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultCustomRowValue3"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodCustomRowValue3"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
              </tr>

              <tr>
                <td class="FontWeight">
                  <el-input
                    v-model="form.SpecificationCustomRowKey4"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.SpecificationCustomRowValue4"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultCustomRowValue4"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodCustomRowValue4"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
              </tr>

              <tr>
                <td class="FontWeight">
                  <el-input
                    v-model="form.SpecificationCustomRowKey5"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.SpecificationCustomRowValue5"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultCustomRowValue5"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodCustomRowValue5"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <el-button
                  style="margin-top: 14px"
                  type="primary"
                  class="button-new-tag"
                  size="small"
                  @click="addAnalysisCustomRow(1, 0)"
                  >+</el-button>
              </tr>
              
              <tr
                v-for="(item, analysisIndexEhxto) in analysisCustomFieldAttr"
                :key="analysisIndexEhxto"
              >
                <td class="FontWeight">
                  <el-input
                    v-model="item.customKey"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="item.customValue"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="item.customValue2"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="item.customValue1"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <el-button
                  type="primary"
                  class="button-new-tag"
                  size="small"
                  @click="addAnalysisCustomRow(1, analysisIndexEhxto)"
                  >+</el-button
                >
                <el-button
                  type="danger"
                  class="button-new-tag"
                  size="small"
                  @click="addAnalysisCustomRow(0, analysisIndexEhxto)"
                  >-</el-button
                >
              </tr>

              <tr>
                <td class="FontWeight">Color</td>
                <td>
                  <el-input
                    v-model="form.SpecificationColor"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultColor"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodColor"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Odor</td>
                <td>
                  <el-input
                    v-model="form.SpecificationOdor"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultOdor"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodOdor"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Taste</td>
                <td>
                  <el-input
                    v-model="form.SpecificationTaste"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultTaste"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodTaste"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>

            </table>
          </div>
        </div>
        <!-- Microbiological Tests -->
        <div class="base-info">
          <div>Microbiological Tests</div>
          <div>
            <table
              class="AnalysisTable"
              border="1"
              cellspacing="0"
              cellpadding="0"
            >
              <tr>
                <td style="width: 25%" class="FontWeight">Test Item</td>
                <td style="width: 25%" class="FontWeight">Specification</td>
                <td style="width: 25%" class="FontWeight">Result</td>
                <td style="width: 25%" class="FontWeight">Test Method</td>
              </tr>
              <tr>
                <td class="FontWeight">Total Plate Count</td>
                <td>
                  <el-input
                    v-model="form.SpecificationTotalPlateCount"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="prepend">
                      <div style="width: 100%">&lt;</div>
                    </template>
                    <template slot="append">
                      <div style="width: 100%">cfu / g</div>
                    </template>
                  </el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultTotalPlateCount"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="append">
                      <div style="width: 100%">cfu / g</div>
                    </template>
                  </el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodTotalPlateCount"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>

              <tr>
                <td class="FontWeight">Yeast and Mold</td>
                <td>
                  <el-input
                    v-model="form.SpecificationYeastAndMold"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="prepend">
                      <div style="width: 100%">&lt;</div>
                    </template>
                    <template slot="append">
                      <div style="width: 100%">cfu / g</div>
                    </template>
                  </el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultYeastAndMold"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="append">
                      <div style="width: 100%">cfu / g</div>
                    </template>
                  </el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodYeastAndMold"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">E. Coli</td>
                <td>
                  <el-input
                    v-model="form.SpecificationEColi"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultEColi"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodEColi"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Salmonella</td>
                <td>
                  <el-input
                    v-model="form.SpecificationSalmonella"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultSalmonella"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodSalmonella"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Staph Aureus</td>
                <td>
                  <el-input
                    v-model="form.SpecificationStaphAureus"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultStaphAureus"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodStaphAureus"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td class="FontWeight">Total Coliforms</td>
                <td>
                  <el-input
                    @blur="checkSpecificationTotalColiforms()"
                    v-model="form.SpecificationTotalColiforms"
                    placeholder="Please Input"
                    class="InputWidth"
                  >
                    <template slot="prepend">
                      <div style="width: 100%">&lt;</div>
                    </template>
                    <template slot="append">
                      <div style="width: 100%">MPN/g</div>
                    </template>
                  </el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.ResultTotalColiforms"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.TestMethodTotalColiforms"
                    placeholder="Please Input"
                    class="InputWidth"
                  ></el-input>
                </td>
              </tr>

              <tr>
                <td class="FontWeight">
                  <el-input
                    v-model="form.MTSpecificationCustomRowKey1"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.MTSpecificationCustomRowValue1"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.MTResultCustomRowValue1"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="form.MTTestMethodCustomRowValue1"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <el-button
                  style="margin-top: 14px"
                  type="primary"
                  class="button-new-tag"
                  size="small"
                  @click="addMicTestsCustomRow(1, 0)"
                  >+</el-button
                >
              </tr>
              
              <tr
                v-for="(item, micTestsIndex) in micTestsCustomFieldAttr"
                :key="micTestsIndex"
              >
                <td class="FontWeight">
                  <el-input
                    v-model="item.customKey"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="item.customValue"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="item.customValue2"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="item.customValue1"
                    class="InputWidth"
                    placeholder="Please Input"
                  ></el-input>
                </td>
                <el-button
                  type="primary"
                  class="button-new-tag"
                  size="small"
                  @click="addMicTestsCustomRow(1, micTestsIndex)"
                  >+</el-button
                >
                <el-button
                  type="danger"
                  class="button-new-tag"
                  size="small"
                  @click="addMicTestsCustomRow(0, micTestsIndex)"
                  >-</el-button
                >
              </tr>
            </table>
          </div>
        </div>
        <NoteTableData :baseInfo="this.$data"></NoteTableData>
        
        <div class="other-notes">
          <div>Notes</div>
          <div style="margin-top:0px;">
            <el-input v-model="newNote" placeholder="Please Input" style="width:600px;margin-bottom:10px;margin-right:10px;"></el-input>
            <el-button type="text" @click="addNewNoteTableClick">
              Complete
            </el-button>
          </div>
        </div>

        <div class="base-info">
          <div>Note:</div>
          <div style="width: 80%; text-align: left; font-weight: bold">
            <div>
              * <el-checkbox v-model="form.note1">
                  Manufacturing Site: Shanghai Tianyuan Plant Products Company, Ltd.  No.18 Hexiang Rd, Baihe Town, Qingpu District, Shanghai.
                </el-checkbox>
            </div>
            <div>
              * <el-checkbox v-model="form.note2">
                  The above listed product is non-irradiated product.
                </el-checkbox>
            </div>
            <div>
              * <el-checkbox v-model="form.note3">
                  This product is intended only for animal use and is not intended for human consumption.
                </el-checkbox>
            </div>
            <div>
              *  Color variation from batch to batch of the product may occur due to natural variations of raw material.
            </div>
            <div>
              * The pH of powder product should be tested in its 1% aqueous solution if necessary.
            </div>
            <div v-for="(item, index) in newNoteArr" :key="index" style="margin-top:0px;">
              <span style="font-weight: 600;">* {{item.content}}</span>
              <el-button type="text" @click="deleteNewNoteTableClick(index)">
                <i style="color:red;font-size:20px;" class="el-icon-delete"></i>
              </el-button>
            </div>
          </div>
        </div>

        <!-- Save -->
        <div class="save-bottom">
          <el-button v-if="userInfo.operateStatus" type="primary" @click="handleNew('ContinueEdit')">Save</el-button>
          <el-button v-if="userInfo.operateStatus" type="primary" @click="inventoryDialogVisible = true">Upload to library</el-button>
          <el-button v-if="userInfo.operateStatus" type="primary" @click="updateBySpec()">COA Update</el-button>
          <el-button @click="back">Back Coa</el-button>
          <el-button type="success" icon="el-icon-printer" @click="printPage()">Print</el-button>
        </div>
      </div>
    </center>
    <el-dialog
      title="Tips"
      :visible.sync="inventoryDialogVisible"
      width="30%"
      style="text-align:left;"
    >
      <span>Please select the type to save</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addToLibrary(1)">Inventory</el-button>
        <el-button type="primary" @click="addToLibrary(2)"
          >Sample Inventory</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import base from "@/common/base.js";
import printJS from "print-js";
import COAPowder from "../PrintProductTypeModule/COA-Powder";
import NoteTableData from "../NoteTableData";
export default {
  props: { baseInfoItemCodeDetail: {},baseinfoCustom:{} },
  mixins: [base],
  components: { COAPowder,NoteTableData },
  data() {
    return {
      inventoryDialogVisible:false,
      addRevNumber:false,
      ingredientsArr: [],
      inputVisible: "",
      inputValue: "",
      ingredientsD: false,

      inclNameArr: [],
      inclNameInputVisible: "",
      inclNameInputValue: "",
      inciNameD: false,

      commonNameArr: [],
      commonNameInputVisible: "",
      commonNameInputValue: "",
      commonNameD: false,

      botanicalNameArr: [],
      botanicalNameInputVisible: "",
      botanicalNameInputValue: "",
      botanicalNameD: false,

      partUsedArr: [],
      partUsedInputVisible: "",
      partUsedInputValue: "",
      partUsedD: false,

      percentageArr: [],
      percentageInputVisible: "",
      percentageInputValue: "",
      percentageD: false,

      printShow: false,
      baseInfoCustomFieldList:[],
      form: {
        baseInfoCustomField:'',
        libraryRevNumber:0,
        libraryCreateTime:'',
        revNumber:1,
        versionNumber:"",
        revDate:[],
        noteTableData:"",
        BaseInfoEditPrintTitle: "",
        BaseInfoEditPrintTitleCheckbox: false,
        productType: "",
        oldProductType: "",
        BaseInfoItemCode: "",
        BaseInfoProductName: "",
        ProductSubType: "",
        BaseInfoLot: "",
        BaseInfoCustomProductName: "",
        BaseInfoCountryofOrigin: "China",
        BaseInfoCustomerPONumber: false, //Checkbox
        BaseInfoCustomerPONumberText: "",
        BaseInfoCustomerCodeCheckbox: false,
        BaseInfoCustomerCode: "",
        BaseInfoCOfOFAndCOfOE: false, //Checkbox
        BaseInfoCOfOFAndCOfOEText: "",
        BaseInfoSAPNumber: false, //Checkbox
        BaseInfoSAPNumberText: "",
        BaseInfoManufacturingDate: "",
        BaseInfoExpirationDate: "",

        BaseInfoCustomRowKey1: "",
        BaseInfoCustomRowValue1: "",
        BaseInfoCustomRowKey2: "",
        BaseInfoCustomRowValue2: "",

        GeneralSpecIngredients: "",
        GeneralSpecProductGrade: "",
        GeneralSpecINCIName: "",
        GeneralSpecBotanicalName: "",
        GeneralSpecCommonNameOrOtherName: "",
        GeneralSpecPartUsed: "",
        GeneralSpecPercentage: "",
        GeneralSpecExtractionRatio: "",
        GeneralSpecImportantConstituentsInPlant: "",
        GeneralSpecHarvestMethod: false,
        GeneralSpecHarvestMethodText: "",
        GeneralSpecAppearance: "",
        GeneralSpecSolubility: "",
        GeneralSpecHomogeneity: "Completely homogenous",
        GeneralSpecExtractionProcess:
          "Controlled-temperature water extraction process, spray dried",
        GeneralSpecProcessingAid: "",
        GeneralSpecSolventForExtraction: "",
        GeneralSpecCarrier: "",
        GeneralSpecPesticides: "",
        GeneralSpecCertification: "",

        GeneralSpecCustomRowKey1: "",
        GeneralSpecCustomRowValue1: "",
        GeneralSpecCustomRowKey2: "",
        GeneralSpecCustomRowValue2: "",
        GeneralSpecCustomRowKey3: "",
        GeneralSpecCustomRowValue3: "",

        SpecificationSTANDARD1: "",
        SpecificationSTANDARD2: "",
        SpecificationSTANDARD3: "",
        SpecificationMeshSize: "",
        SpecificationLossOnDrying: "",
        SpecificationBulkDensity: "",
        SpecificationIdentification: "Conforms",
        SpecificationTotalHeavyMetals: "",
        SpecificationArsenic: "",
        SpecificationCadmium: "",
        SpecificationLead: "",
        SpecificationMercury: "",
        SpecificationColor: "",
        SpecificationOdor: "Compares to standard",
        SpecificationTaste: "Compares to standard",

        ResultSTANDARD1: "",
        ResultSTANDARD2: "",
        ResultSTANDARD3: "",
        ResultMeshSize: "",
        ResultLossOnDrying: "",
        ResultBulkDensity: "",
        ResultIdentification: "Passes",
        ResultTotalHeavyMetals: "<10",
        ResultArsenic: "",
        ResultCadmium: "",
        ResultLead: "",
        ResultMercury: "",
        ResultColor: "",
        ResultOdor: "Compares to standard",
        ResultTaste: "Compares to standard",

        TestMethodSTANDARD1: "",
        TestMethodSTANDARD2: "",
        TestMethodSTANDARD3: "",
        TestMethodMeshSize: "Metric Sieve",
        TestMethodLossOnDrying: "Draco-1.1.1.0",
        TestMethodBulkDensity: "USP <616>",
        TestMethodIdentification: "HPTLC",
        TestMethodTotalHeavyMetals: "USP <231>",
        TestMethodArsenic: "ICP-MS",
        TestMethodCadmium: "ICP-MS",
        TestMethodLead: "ICP-MS",
        TestMethodMercury: "ICP-MS",
        TestMethodColor: "Visual",
        TestMethodOdor: "Organoleptic",
        TestMethodTaste: "Organoleptic",

        SpecificationTotalPlateCount: "",
        SpecificationYeastAndMold: "",
        SpecificationEColi: "Negative",
        SpecificationSalmonella: "",
        SpecificationStaphAureus: "",
        SpecificationTotalColiforms: "",

        ResultTotalPlateCount: "",
        ResultYeastAndMold: "",
        ResultEColi: "Negative",
        ResultSalmonella: "Negative",
        ResultStaphAureus: "Negative",
        ResultTotalColiforms: "<10 MPN/g",

        TestMethodTotalPlateCount: "FDA-BAM",
        TestMethodYeastAndMold: "FDA-BAM",
        TestMethodEColi: "FDA-BAM",
        TestMethodSalmonella: "FDA-BAM",
        TestMethodStaphAureus: "FDA-BAM",
        TestMethodTotalColiforms: "FDA-BAM",

        SpecificationCustomRowKey1: "",
        SpecificationCustomRowValue1: "",
        ResultCustomRowKey1: "",
        ResultCustomRowValue1: "",
        TestMethodCustomRowKey1: "",
        TestMethodCustomRowValue1: "",

        SpecificationCustomRowKey2: "",
        SpecificationCustomRowValue2: "",
        ResultCustomRowKey2: "",
        ResultCustomRowValue2: "",
        TestMethodCustomRowKey2: "",
        TestMethodCustomRowValue2: "",

        SpecificationCustomRowKey3: "",
        SpecificationCustomRowValue3: "",
        ResultCustomRowKey3: "",
        ResultCustomRowValue3: "",
        TestMethodCustomRowKey3: "",
        TestMethodCustomRowValue3: "",

        SpecificationCustomRowKey4: "",
        SpecificationCustomRowValue4: "",
        ResultCustomRowKey4: "",
        ResultCustomRowValue4: "",
        TestMethodCustomRowKey4: "",
        TestMethodCustomRowValue4: "",

        SpecificationCustomRowKey5: "",
        SpecificationCustomRowValue5: "",
        ResultCustomRowKey5: "",
        ResultCustomRowValue5: "",
        TestMethodCustomRowKey5: "",
        TestMethodCustomRowValue5: "",

        MTSpecificationCustomRowKey1: "",
        MTSpecificationCustomRowValue1: "",
        MTResultCustomRowKey1: "",
        MTResultCustomRowValue1: "",
        MTTestMethodCustomRowKey1: "",
        MTTestMethodCustomRowValue1: "",

        MTSpecificationCustomRowKey2: "",
        MTSpecificationCustomRowValue2: "",
        MTResultCustomRowKey2: "",
        MTResultCustomRowValue2: "",
        MTTestMethodCustomRowKey2: "",
        MTTestMethodCustomRowValue2: "",

        MTSpecificationCustomRowKey3: "",
        MTSpecificationCustomRowValue3: "",
        MTResultCustomRowKey3: "",
        MTResultCustomRowValue3: "",
        MTTestMethodCustomRowKey3: "",
        MTTestMethodCustomRowValue3: "",
        
        genSpecCustomField: "",
        analysisCustomField: "",
        micTestsCustomField: "",
        note1:false,
        note2:false,
        note3:false,
        
        tableInput1:"",
        tableInput2:"",
        tableInput3:"",
        tableInput4:"",
        tableInput5:"",
        tableInputCustomField:"",
      },
      formData: {
        id: 0,
        productName: "",
        itemCode: "",
        lot: "",
        jsonValue: {},
        updateName:"",
        updateTime:base.methods.getLocalNowTime(),
        createTime:base.methods.getLocalNowTime(),
      },
      printObj: {
        id: "printDiv", // 这里是要打印元素的ID
        popTitle: "", // 打印的标题
        extraCss: "", // 打印可引入外部的一个 css 文件
        extraHead: "", // 打印头部文字
      },
      createTime: base.methods.getLocalNowTime(),
      
      genSpecCustomFieldAttr: [],
      analysisCustomFieldAttr: [],
      micTestsCustomFieldAttr: [],
      customField: {
        customKey: "",
        customValue: "",
        customKey1: "",
        customValue1: "",
        customKey2: "",
        customValue2: "",
      },
      tableInputCustomFieldAttr: [],
      tableInputField: {
        tableInput1: "",
        tableInput2: "",
        tableInput3: "",
        tableInput4: "",
        tableInput5: "",
      },
      isShowAlonePrint:false,
      isShowUpdate:false,
      shelflifeNumber:0,
      noteTableData: [
        {
          revisionDate: "",
          requestedBy: "",
          itemsRevised: "",
          editedBy: "",
          reason:"",
          approvedBy: "",
          isComplete:false,
        },
      ],
      newNoteArr:[],
      newNote:"",
    };
  },
  methods: {
    back() {
      this.$router.push({ path: "/coa-items" });
    },
    showUpdate(){
      this.isShowAlonePrint = false
      this.$parent.isShowAlonePrint = false
    },
    closePage(){
      if (navigator.userAgent.indexOf('MSIE') > 0) { // close IE
        if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
          window.opener = null;
          window.close();
        } else {
          window.open('', '_top');
          window.top.close();
        }
      } else { // close chrome;It is effective when it is only one.
        window.opener = null;
        window.open('', '_self');
        window.close();
      }
    },
    checkSpecificationTotalColiforms(){
      this.form.SpecificationTotalColiforms=this.form.SpecificationTotalColiforms.toLowerCase()=='negative'?this.form.SpecificationTotalColiforms:this.form.SpecificationTotalColiforms.replace(/[^\d.]|/g,'')
    },
    updateBySpec(){
      this.$confirm(
        "Are you sure synchronize the spec content. Continue?",
        "Tips",
        {
          confirmButtonText: "Ok",
          cancelButtonText: "Cancel",
          distinguishCancelAndClose: true,
          type: "warning",
        }
      ).then(() => {
        this.loading = true;
        this.$api.handleSpec
        .getDetailByItemCode(this.$parent.params.BaseInfoItemCode)
        .then((res) => {
          if (res.jsonValue != undefined) {
            console.log('getDetailByItemCode==res')
            console.log(res)
            this.$parent.params.BaseInfoProductName = res.productName;
            this.$parent.revDateTime =base.methods.getLocalNowTime();
            let jsonValue = JSON.parse(res.jsonValue)
            console.log('revNumber==='+jsonValue.revNumber)
            this.$parent.params.revNumber = jsonValue.revNumber;
            console.log('this.$parent.params.revNumber==='+this.$parent.params.revNumber)

            this.getBaseInfoDetail(jsonValue)
            this.handleNew('ContinueEdit')
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
      });
    },
    handleNew(type) {
      let params = { ...this.$route.query };
      console.log("=============");
      console.log(this.$parent.params);
      this.form.baseInfoCustomField = JSON.stringify(this.$parent.BaseInfoCustomFieldAttr);
      this.form.productType = this.$parent.params.productType;
      this.form.oldProductType = this.$parent.params.oldProductType;
      this.form.ProductSubType = this.$parent.params.ProductSubType;
      this.form.BaseInfoItemCode = this.$parent.params.BaseInfoItemCode;
      this.form.BaseInfoProductName = this.$parent.params.BaseInfoProductName;
      this.form.BaseInfoLot = this.$parent.params.BaseInfoLot;
      this.form.versionNumber = this.$parent.params.versionNumber
      this.form.revNumber = this.$parent.params.revNumber

      this.form.noteTableData = JSON.stringify(this.noteTableData) 
      this.form.newNoteArr = JSON.stringify(this.newNoteArr) 
      // let revNumber = 0
      // this.noteTableData.forEach(item=>{
      //   if(item.isComplete){
      //     revNumber ++
      //   }
      // })
      // this.form.revNumber = revNumber

      this.form.GeneralSpecINCIName = this.inclNameArr.join("_");
      this.form.GeneralSpecCommonNameOrOtherName = this.commonNameArr.join("_");
      this.form.GeneralSpecBotanicalName = this.botanicalNameArr.join("_");
      this.form.GeneralSpecPartUsed = this.partUsedArr.join("_");
      this.form.GeneralSpecIngredients = this.ingredientsArr.join("_");
      this.form.GeneralSpecPercentage = this.percentageArr.join("_");
      
      this.form.genSpecCustomField = JSON.stringify(this.genSpecCustomFieldAttr) 
      this.form.analysisCustomField = JSON.stringify(this.analysisCustomFieldAttr) 
      this.form.micTestsCustomField = JSON.stringify(this.micTestsCustomFieldAttr)
      this.form.tableInputCustomField = JSON.stringify(this.tableInputCustomFieldAttr)  

      let jsonStr = JSON.stringify(this.form);
      console.log("jsonStr:" + jsonStr);
      this.formData.productName = this.form.BaseInfoProductName;
      this.formData.itemCode = this.form.BaseInfoItemCode;
      this.formData.lot = this.form.BaseInfoLot;
      this.formData.jsonValue = jsonStr;
      console.log("formData:" + this.formData);
      if (params.id) {
        this.form.revDate.push(this.$parent.revDateTime)
        jsonStr = JSON.stringify(this.form);
        this.formData.jsonValue = jsonStr;
        // this.formData.id = params.id;
        this.$api.coa
          .editCoaUrl(this.formData)
          .then(() => {
            this.$message({
              type: "success",
              message: "SuccessFul",
            });
            this.$parent.revDateTime = base.methods.getLocalNowTime()
            this.reloadPage(type);
            // this.addToLibrary(this.formData.id)
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
            console.log(err);
          });
      } else {
        this.$api.coa
          .addCoaUrl(this.formData)
          .then((res) => {
            this.$message({
              type: "success",
              message: "SuccessFul",
            });
            console.log("提交返回成功");
            console.log(res);
            // this.$router.push({
            //   path: "coa-items",
            // });
            // this.reloadPage(type);
            this.$parent.revDateTime = base.methods.getLocalNowTime()
            if(type == 1 || type == 2){
              this.batchAddLibrary(res,type)
            }
            this.$confirm("Return to list page, Continue?", "Tips", {
              confirmButtonText: "Ok",
              cancelButtonText: "Cancel",
              distinguishCancelAndClose: true,
              type: "warning"
            }).then(() => {
              this.$router.push({
                path: "coa-items"
              });
            });
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
            console.log(err);
          });
      }
    },
    reloadPage(type){
      if (type == "Save&New") {
        //清空数据
        this.$router.push({
          path: "coa-item",
          query: { productType: "Powder" },
        });
        this.$router.go(0);
      }
    },
    getDetailById(params) {
      this.$parent.loading = true;
      this.$api.coa.handleCoaTableUrl(params).then((data) => {
        console.log("data:");
        console.log(data);
        this.formData = data;
        this.form = JSON.parse(data.jsonValue);
        console.log("form:");
        console.log(this.form);
        if(this.form.productType =='power'){
          this.form.productType ='Powder'
        }

        if(this.form.newNoteArr == undefined){
          this.form.newNoteArr = []
          this.newNoteArr = []
        }
        else{
          try{
            this.newNoteArr = JSON.parse(this.form.newNoteArr);
          }
          catch(err){
            console.log('getDetailById========newNoteArr')
            console.log(err)
            this.newNoteArr = []
          }
        }

        if(this.form.noteTableData){
          this.noteTableData = JSON.parse(this.form.noteTableData);
        }
        if(this.form.revNumber == undefined){
          this.form.revNumber = 0
          console.log('getDetailById========revNumber')
        }
        if(this.form.revDate == undefined){
          this.form.revDate = []
        }
        console.log('this.form.revDate')
        console.log(this.form.revDate)

        console.log('this.form.revNumber')
        console.log(this.form.revNumber)

        if (this.form.BaseInfoManufacturingDate == "NaN-aN-aN") {
          this.form.BaseInfoManufacturingDate = "";
          this.form.BaseInfoExpirationDate = "";
        }
        this.$parent.params = this.form;
        if(this.form.baseInfoCustomField){
          this.$parent.BaseInfoCustomFieldAttr = JSON.parse(this.form.baseInfoCustomField)
          this.baseInfoCustomFieldList = JSON.parse(this.form.baseInfoCustomField)
        }
        console.log("params");
        console.log(this.$parent.params);

        console.log("GeneralSpecINCIName");
        console.log(this.form.GeneralSpecINCIName);

        this.strSplit(this.form.GeneralSpecINCIName, "inclNameArr");
        this.strSplit(
          this.form.GeneralSpecCommonNameOrOtherName,
          "commonNameArr"
        );
        this.strSplit(this.form.GeneralSpecBotanicalName, "botanicalNameArr");
        this.strSplit(this.form.GeneralSpecPartUsed, "partUsedArr");

        this.strSplit(this.form.GeneralSpecIngredients, "ingredientsArr");
        this.strSplit(this.form.GeneralSpecPercentage, "percentageArr");

        if (this.form.genSpecCustomField) {
          this.genSpecCustomFieldAttr=JSON.parse(this.form.genSpecCustomField)
        }
        if (this.form.analysisCustomField) {
          this.analysisCustomFieldAttr=JSON.parse(this.form.analysisCustomField)
        }
        if (this.form.micTestsCustomField) {
          this.micTestsCustomFieldAttr=JSON.parse(this.form.micTestsCustomField)
        }
        if (this.form.tableInputCustomField) {
          this.tableInputCustomFieldAttr=JSON.parse(this.form.tableInputCustomField)
        }
        this.$parent.loading = false;
        this.$parent.revDateTime = data.updateTime
      })
      .catch((err) => {
        this.$message({
          type: "error",
          message: err,
        });
        console.log(err);
        this.$parent.loading = false;
      });
    },
    manufacturingDateChange() {
      this.form.BaseInfoManufacturingDate = this.addDate(10,new Date(this.form.BaseInfoManufacturingDate),"day");

      this.form.BaseInfoExpirationDate = this.addDate(this.shelflifeNumber,new Date(this.form.BaseInfoManufacturingDate),"month");
      this.form.BaseInfoExpirationDate = this.addDate(10,new Date(this.form.BaseInfoExpirationDate),"day");

      this.form.BaseInfoManufacturingDate = this.formatTime(this.form.BaseInfoManufacturingDate,"yyyy-MM-dd");
      this.form.BaseInfoExpirationDate = this.formatTime(this.form.BaseInfoExpirationDate,"yyyy-MM-dd");
      
      console.log(this.form.BaseInfoManufacturingDate)
      console.log(this.form.BaseInfoExpirationDate)
    },
    printPage() {
      if (this.formData.id) {
        console.log("true" + this.formData.id);
      } else {
        console.log("false" + this.formData.id);
      }
      this.form.BaseInfoItemCode = this.$parent.params.BaseInfoItemCode;
      this.form.BaseInfoProductName = this.$parent.params.BaseInfoProductName;
      this.form.versionNumber = this.$parent.params.versionNumber;
      this.form.BaseInfoLot = this.$parent.params.BaseInfoLot;
      this.printShow = true;
      const style = "@page {margin:0} @media print{}";
      //console.log(this.formModel);
      var printFileName = "";
      // if(this.form.BaseInfoProductName != undefined && this.form.BaseInfoProductName != ""){
      //   printFileName = this.form.BaseInfoProductName.replace(":","~").replace("：", "~");
      // }
      // if(this.form.BaseInfoLot != undefined && this.form.BaseInfoLot != ""){
      //   printFileName = printFileName + this.form.BaseInfoLot;
      // }
      printFileName = "(CoA)"+this.form.BaseInfoProductName+this.form.BaseInfoLot+"Rev."+this.$parent.params.revNumber
      console.log(printFileName);
      document.title = printFileName;
      setTimeout(() => {
        printJS({
          printable: "printDiv",
          type: "html",
          style: style,
          scanStyles: false,
        });
      }, 1.5);

      setTimeout(() => {
        this.printShow = false;
      }, 3);
    },
    aloneprintPage() {
      this.form.BaseInfoItemCode = this.$parent.params.BaseInfoItemCode;
      this.form.BaseInfoProductName = this.$parent.params.BaseInfoProductName;
      this.form.versionNumber = this.$parent.params.versionNumber;
      this.form.BaseInfoLot = this.$parent.params.BaseInfoLot;
      const style = "@page {margin:0;} @media print{}";
      var printFileName = ""; 
      printFileName = "(CoA)"+this.form.BaseInfoProductName+this.form.BaseInfoLot
      
      document.title = printFileName;
      setTimeout(() => {
        printJS({
          printable: "alonePrintDiv",
          type: "html",
          style: style,
          scanStyles: false,
          documentTitle: printFileName,
        });
      }, 1.5);
    },
    tagHandle(array, tagCotext, index) {
      //tag标签点击事件
      console.info(array, tagCotext, index);
      this.$prompt("修改值-->" + tagCotext, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          array.splice(index, 1, value);
        })
        .catch(() => {});
    }, // ingredients标签操作
    handleClose(tag, arr) {
      this[arr].splice(this[arr].indexOf(tag), 1);
    },
    showInput: function (inputVisible, ref) {
      console.log(inputVisible);
      this[inputVisible] = true;
      this.$nextTick(() => {
        this.$refs[ref].$refs.input.focus();
      });
    },
    handleInputConfirm(value, arr, visible) {
      let inputValue = this[value];
      if (inputValue) {
        console.info(this[arr]);
        this[arr].push(inputValue);
      }

      this[visible] = false;
      this[value] = "";
    },
    strSplit(context, type) {
      this[type] = []; //清理旧有数据防止重复
      if (!context) {
        return;
      }
      let splitArr = context.split("_");
      if (splitArr.length == 1) {
        splitArr = context.split(",");
      }
      splitArr.forEach((v) => {
        if (v.trim().length != 0) {
          this[type].push(v);
        }
      });
    },
    addGenSpecCustomRow(type, index) {
      if (type == 1) {
        this.genSpecCustomFieldAttr.push({ ...this.customField });
      } else {
        this.$delete(this.genSpecCustomFieldAttr, index);
      }
    },
    addAnalysisCustomRow(type, index) {
      if (type == 1) {
        this.analysisCustomFieldAttr.push({ ...this.customField });
      } else {
        this.$delete(this.analysisCustomFieldAttr, index);
      }
    },
    addMicTestsCustomRow(type, index) {
      if (type == 1) {
        this.micTestsCustomFieldAttr.push({ ...this.customField });
      } else {
        this.$delete(this.micTestsCustomFieldAttr, index);
      }
    },
    addTableInput(type,index){
      if(type==1){
        this.tableInputCustomFieldAttr.push({ ...this.tableInputField });
      }
      else{
        this.$delete(this.tableInputCustomFieldAttr,index)
      }
    },
    addToLibrary(inventoryType){
      this.inventoryDialogVisible = false;
      let paramsQuery = { ...this.$route.query };
      if (paramsQuery.id) {
        this.batchAddLibrary(paramsQuery.id,inventoryType)
      }
      else{
        this.handleNew(inventoryType)
      }
    },
    batchAddLibrary(id,inventoryType){
      this.$confirm(
          "Are you sure batch add. Continue?",
          "Tips",
          {
            confirmButtonText: "Ok",
            cancelButtonText: "Cancel",
            distinguishCancelAndClose: true,
            type: "warning",
          }
        ).then(() => {
          let params ={ids:[id],type:'coa',inventoryType: inventoryType}
          console.log('addToLibrary======params')
          console.log(params)
          this.$api
            .batchAddLibrary(params)
            .then(() => {
              this.$message({ type: "success", message: "batch Add SuccessFully" });
              this.form.libraryRevNumber = this.form.revNumber
              this.form.libraryCreateTime = base.methods.formatTime(base.methods.getLocalNowTime(),"dd/MM/yyyy hh:mm")
              let jsonStr = JSON.stringify(this.form);
              this.formData.jsonValue = jsonStr;
              this.formData.id = id
              this.$api.coa.editCoaUrl(this.formData).then(() => {
                console.log("editCoaUrl====SuccessFul")
                this.$message({
                  type: "success",
                  message: "SuccessFul",
                });
                this.verifyChange(id)
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err,
                });
                console.log(err);
              });
            })
            .catch((err) => {
              console.log(err);
            });
        });
    },
    getBaseInfoDetail(newVal){
      console.log('getBaseInfoDetailgetBaseInfoDetailgetBaseInfoDetail')
      console.log(newVal)
      this.shelflifeNumber = newVal.shelflifeNumber!= undefined ? parseInt(newVal.shelflifeNumber): 36
      console.log("this.shelflifeNumber==="+this.shelflifeNumber)

      if(newVal.newNoteArr == undefined){
        this.form.newNoteArr = []
        this.newNoteArr = []
      }
      else{
        this.newNoteArr = JSON.parse(newVal.newNoteArr);
      }
      this.form.oldProductType = newVal.productType
      this.form.ProductSubType = newVal.productSubType
      this.form.versionNumber = newVal.versionNumber;
      this.form.revNumber = newVal.revNumber
      console.log("this.form.revNumber==="+this.form.revNumber)
        
      //this.form.BaseInfoCustomerPONumber= newVal.commonName; //Checkbox
      //this.form.BaseInfoCOfOFAndCOfOE= newVal.commonName; //Checkbox
      //this.form.BaseInfoSAPNumber= newVal.commonName; //Checkbox
      //this.form.BaseInfoManufacturingDate= newVal.commonName;
      //this.form.BaseInfoExpirationDate= newVal.commonName;
      
      this.form.GeneralSpecCustomRowKey1=newVal.generalSpecificationKey1;
      this.form.GeneralSpecCustomRowValue1=newVal.generalSpecificationValue1;
      this.form.GeneralSpecCustomRowKey2=newVal.generalSpecificationKey2;
      this.form.GeneralSpecCustomRowValue2=newVal.generalSpecificationValue2;
      this.form.GeneralSpecCustomRowKey3=newVal.generalSpecificationKey3;
      this.form.GeneralSpecCustomRowValue3=newVal.generalSpecificationValue3;

      this.form.SpecificationCustomRowKey1=newVal.specificationCustomerKey1;
      this.form.SpecificationCustomRowValue1=newVal.specificationCustomerValue1;
      this.form.TestMethodCustomRowKey1=newVal.testMethodCustomerKey1;
      this.form.TestMethodCustomRowValue1=newVal.testMethodCustomerValue1;
      this.form.SpecificationCustomRowKey2=newVal.specificationCustomerKey2;
      this.form.SpecificationCustomRowValue2=newVal.specificationCustomerValue2;
      this.form.TestMethodCustomRowKey2=newVal.testMethodCustomerKey2;
      this.form.TestMethodCustomRowValue2=newVal.testMethodCustomerValue2;
      this.form.SpecificationCustomRowKey3=newVal.specificationCustomerKey3;
      this.form.SpecificationCustomRowValue3=newVal.specificationCustomerValue3;
      this.form.TestMethodCustomRowKey3=newVal.testMethodCustomerKey3;
      this.form.TestMethodCustomRowValue3=newVal.testMethodCustomerValue3;
      this.form.SpecificationCustomRowKey4=newVal.specificationCustomerKey4;
      this.form.SpecificationCustomRowValue4=newVal.specificationCustomerValue4;
      this.form.TestMethodCustomRowKey4=newVal.testMethodCustomerKey4;
      this.form.TestMethodCustomRowValue4=newVal.testMethodCustomerValue4;
      this.form.SpecificationCustomRowKey5=newVal.specificationCustomerKey5;
      this.form.SpecificationCustomRowValue5=newVal.specificationCustomerValue5;
      this.form.TestMethodCustomRowKey5=newVal.testMethodCustomerKey5;
      this.form.TestMethodCustomRowValue5=newVal.testMethodCustomerValue5;


      this.form.MTSpecificationCustomRowKey1=newVal.microbiologicalCustomerKey1;
      this.form.MTSpecificationCustomRowValue1=newVal.microbiologicalCustomerValue1;
      this.form.MTTestMethodCustomRowValue1=newVal.microbiologicalTestMethodCustomerValue1;

      this.form.GeneralSpecIngredients = newVal.ingredients;
      if (newVal.productType == "PCG") {
        this.form.GeneralSpecProductGrade = 'Personal Care Grade';
      }
      else {
        this.form.GeneralSpecProductGrade = newVal.productGrade;
      }
      this.form.GeneralSpecINCIName = newVal.inciName;
      this.form.GeneralSpecBotanicalName = newVal.botanicalName;
      this.form.GeneralSpecCommonNameOrOtherName = newVal.commonOtherName;
      this.form.GeneralSpecPartUsed = newVal.partUsed;
      this.form.GeneralSpecPercentage = newVal.percentage;
      this.form.GeneralSpecExtractionRatio = newVal.extractionRatio;
      this.form.GeneralSpecImportantConstituentsInPlant = newVal.importantConstitueInPlant;
      //this.form.GeneralSpecHarvestMethod= newVal.commonName;
      this.form.GeneralSpecAppearance = newVal.appearance;
      this.form.GeneralSpecSolubility = newVal.solubility;
      //this.form.GeneralSpecHomogeneity= newVal.homogeneity;
      this.form.GeneralSpecExtractionProcess= newVal.ehxtoExtractionProcess;
      this.form.GeneralSpecProcessingAid = newVal.processingAid;
      if (newVal.productType == "EHXTO") {
        this.form.GeneralSpecSolventForExtraction =
          newVal.ehxtoSolventExtraction;
      } else {
        this.form.GeneralSpecSolventForExtraction =
          newVal.solventForExtracti;
      }
      // if (!this.form.GeneralSpecSolventForExtraction) {
      //   this.form.GeneralSpecSolventForExtraction = "water";
      // }

      this.form.GeneralSpecCarrier = newVal.carrier;

      if (newVal.productType == "EHXTO") {
        this.form.GeneralSpecPesticides = newVal.ehxtoPesticides;
      } else {
        this.form.GeneralSpecPesticides = newVal.pesticides;
      }

      this.form.GeneralSpecCertification = newVal.certification;

      this.form.SpecificationSTANDARD1 = newVal.specificationStandard1;
      this.form.SpecificationSTANDARD2 = newVal.specificationStandard2;
      this.form.SpecificationSTANDARD3 = newVal.specificationStandard3;
      this.form.SpecificationMeshSize = newVal.specificationMeshSize;
      this.form.SpecificationLossOnDrying = newVal.specificationLossonDrying;
      this.form.SpecificationBulkDensity = newVal.specificationBulkDensity;
      this.form.SpecificationTotalHeavyMetals = newVal.specificationTotalHeavyMetals;
      this.form.SpecificationArsenic = newVal.specificationArsenic;
      this.form.SpecificationCadmium = newVal.specificationCadmium;
      this.form.SpecificationLead = newVal.specificationLead;
      this.form.SpecificationMercury = newVal.specificationMercury;
      this.form.SpecificationColor = newVal.specificationColor;

      this.form.SpecificationOdor = newVal.specificationOrdor;
      this.form.SpecificationTaste = newVal.specificationTaste;
      
      this.form.TestMethodArsenic = newVal.testMethodArsenic;
      this.form.TestMethodCadmium = newVal.testMethodCadmium;
      this.form.TestMethodLead = newVal.testMethodLead;
      this.form.TestMethodMercury = newVal.testMethodMercury;
      this.form.TestMethodColor = 'Visual';// newVal.testMethodColor;
      this.form.TestMethodOdor = newVal.testMethodOrdor;
      this.form.TestMethodTaste = newVal.testMethodTaste;

      this.form.TestMethodSTANDARD1 = newVal.testMethodStandard1;
      this.form.TestMethodSTANDARD2 = newVal.testMethodStandard2;
      this.form.TestMethodSTANDARD3 = newVal.testMethodStandard3;

      this.form.SpecificationTotalPlateCount = newVal.specificationTotalPlateCount;
      this.form.SpecificationYeastAndMold = newVal.specificationYeastAndMold;
      this.form.SpecificationEColi = newVal.specificationEcoli;
      this.form.SpecificationSalmonella = newVal.specificationSalmonella;
      this.form.SpecificationStaphAureus = newVal.specificationStaphAureus;
      this.form.SpecificationTotalColiforms = newVal.specificationTotalColiforms;

      this.form.TestMethodTotalPlateCount = newVal.testMethodTotalPlateCount;
      this.form.TestMethodYeastAndMold = newVal.testMethodYeastAndMold;
      this.form.TestMethodEColi = newVal.testMethodEcoli;
      this.form.TestMethodSalmonella = newVal.testMethodSalmonella;
      this.form.TestMethodStaphAureus = newVal.testMethodTaphAureus;
      this.form.TestMethodTotalColiforms = newVal.testMethodTotalColiforms;
      
      
      // if(!this.form.SpecificationEColi){
      //   this.form.SpecificationEColi = newVal.specificationEColi;
      // }
      // if(!this.form.SpecificationEColi){
      //   this.form.SpecificationEColi = "Negative";
      // }

      this.form.genSpecCustomField = newVal.genSpecCustomField;
      this.form.analysisCustomField = newVal.analysisCustomField;
      this.form.micTestsCustomField = newVal.micTestsCustomField;
      this.form.tableInputCustomField = newVal.tableInputCustomField;
      this.form.tableInput1 = newVal.tableInput1;
      this.form.tableInput2 = newVal.tableInput2;
      this.form.tableInput3 = newVal.tableInput3;
      this.form.tableInput4 = newVal.tableInput4;
      this.form.tableInput5 = newVal.tableInput5;
      
      if (this.form.genSpecCustomField) {
        this.genSpecCustomFieldAttr=JSON.parse(this.form.genSpecCustomField)
      }
      if (this.form.analysisCustomField) {
        this.analysisCustomFieldAttr=JSON.parse(this.form.analysisCustomField)
      }
      if (this.form.micTestsCustomField) {
        this.micTestsCustomFieldAttr=JSON.parse(this.form.micTestsCustomField)
      }        
      if (this.form.tableInputCustomField) {
        this.tableInputCustomFieldAttr=JSON.parse(this.form.tableInputCustomField)
      }


      this.strSplit(this.form.GeneralSpecINCIName, "inclNameArr");
      this.strSplit(this.form.GeneralSpecCommonNameOrOtherName, "commonNameArr");
      this.strSplit(this.form.GeneralSpecBotanicalName, "botanicalNameArr");
      this.strSplit(this.form.GeneralSpecPartUsed, "partUsedArr");
      this.strSplit(this.form.GeneralSpecIngredients, "ingredientsArr");
      this.strSplit(this.form.GeneralSpecPercentage, "percentageArr");
      console.log(this.form);
    },
    fatherMethod(revNumber){
      console.log('revNumber')
      console.log(revNumber)
      this.$parent.params.revNumber = revNumber
    },
    addNewNoteTableClick(){
      this.newNoteArr.push({
        content:this.newNote
      })
      this.newNote = ''
    },
    deleteNewNoteTableClick(index){
      this.newNoteArr.splice(index,1);
      // this.$delete(this.newNoteArr,index)
    },
    verifyChange(pId=0) {
      console.log("pId==="+pId)
      let params = {
        id: pId !=0 ? pId : this.$route.query.id,
        isFlag: true,
      };
      this.$api.coa
        .verfiedCoaItem(params)
        .then((data) => {
          console.log(data);
          this.$message({ type: "success", message: "Verified SuccessFul" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("specUserInfo"));
    if(userInfo){
      this.formData.updateName = userInfo.username
    }
  },
  mounted() {
    let params = { ...this.$route.query };
    if (params.id) {
      if(params.aloneprint){
        this.isShowAlonePrint = params.aloneprint == "1" ? true : false
      }
      if(params.showUpdate){
        this.isShowUpdate = params.showUpdate == "1" ? true : false
      }
      this.getDetailById(params);
    }
    let localData = localStorage.getItem("tpsDataKey");
    let data;
    if (localData != "undefined") {
      data = JSON.parse(localStorage.getItem("tpsDataKey"));
    }

    if (data) {
      Object.keys(data).forEach((key) => {
        this.form[key] = data[key];
      });
    }
  },
  watch: {
    baseInfoItemCodeDetail: {
      handler(newVal) {
        console.log("========newVal========");
        console.log(newVal);
        this.getBaseInfoDetail(newVal)
      },
      //为了发现内部的内容发生了变化把状态改变成true
      deep: true,
      immediate: true,//首次赋值的时候也会触发watch里面的handler事件
    },
    baseinfoCustom: {
      handler(newVal) {
        console.log("======Liquid-baseinfoCustombaseinfoCustombaseinfoCustombaseinfoCustom-start==========");
        this.baseInfoCustomFieldList = newVal
        console.log(newVal);
      },
      //为了发现内部的内容发生了变化把状态改变成true
      deep: true,
      immediate: true //首次赋值的时候也会触发watch里面的handler事件
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../module/NewItemStyle.scss";
</style>
<style>
@import "../module/CoaStyle.css";
</style>

